module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "name": "client-search",
      "label": "Search",
      "hint": _vm.hintText,
      "append-icon": "search",
      "prepend-icon": _vm.prependIcon,
      "loading": _vm.clientsRequest.loading,
      "browser-autocomplete": "off",
      "box": "",
      "clearable": "",
      "autofocus": "",
      "id": "client-search"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchClients(_vm.searchString)
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.searchString = ''
      },
      "click:prepend": _vm.newClient
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), (_vm.spaceName) ? _c('div', {
    staticClass: "caption px-2 blue lighten-4",
    attrs: {
      "type": "info"
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("info")]), _vm._v("\n  Only showing clients in "), _c('i', [_vm._v(_vm._s(_vm.spaceName))]), _vm._v(" "), (_vm.includeOwnedByMe) ? _c('i', [_vm._v(" or owned by me")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.withClientsInRange && (!_vm.searchString || _vm.searchString.length === 0)) ? _c('div', [_c('v-subheader', {
    staticClass: "overline pl-1 my-0"
  }, [_vm._v("\n      People you've seen in this period\n      "), _c('v-spacer')], 1), _vm._v(" "), (_vm.withNotInvoicedFilter) ? _c('v-checkbox', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "label": "show only people who have not been invoiced"
    },
    model: {
      value: (_vm.showOnlyNotInvoiced),
      callback: function($$v) {
        _vm.showOnlyNotInvoiced = $$v
      },
      expression: "showOnlyNotInvoiced"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.quicklist), function(clientId, index) {
    return _c('v-chip', {
      key: ("chip-" + clientId + "-" + index),
      attrs: {
        "small": "",
        "label": ""
      },
      on: {
        "click": function($event) {
          _vm.clientSelected(_vm.getRelationByClientId(clientId))
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.formatFullName(_vm.getClientById(clientId))) + "\n    ")])
  }), _vm._v(" "), (_vm.showList) ? _c('v-subheader', {
    staticClass: "overline pl-1 my-0"
  }, [_vm._v("\n      Other contacts\n      "), _c('v-spacer')], 1) : _vm._e()], 2) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showList),
      expression: "showList"
    }],
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.filteredClients), function(client, index) {
    return [_c('client-list-item', {
      key: ("cli-" + (client.id) + "-" + index),
      class: {
        "blue lighten-5": (_vm.selected && _vm.selected.id === client.id)
      },
      attrs: {
        "client": client.client,
        "relationship-id": client.id,
        "owner": client.practitioner,
        "spaces": client.spaces,
        "with-details": false,
        "with-action": _vm.withAction,
        "with-whats-app": _vm.withWhatsApp
      },
      on: {
        "listitem:clicked": function($event) {
          return _vm.clientSelected(client)
        }
      }
    }), _vm._v(" "), _c('v-divider', {
      key: ("div-" + (client.id) + "-" + index)
    })]
  }), _vm._v(" "), (_vm.limit <= _vm.filteredClients.length) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-btn', {
    attrs: {
      "block": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.limit = _vm.limit + _vm.page
      }
    }
  }, [_vm._v("load more")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.searchString && _vm.searchString.length > 0) ? _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-alert', {
    staticClass: "amber py-1",
    attrs: {
      "dismissible": "",
      "type": "warning",
      "value": _vm.spaceName && _vm.filteredClients.length === 0
    }
  }, [_vm._v("\n        Only showing clients shared with " + _vm._s(_vm.spaceName) + ".\n        If you cannot find a specific client, you may need to share them with this space\n      ")]), _vm._v(" "), _c('v-card-actions', [_vm._v("\n        " + _vm._s(Math.min(_vm.limit, _vm.filteredClients.length)) + " results found\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "outline": "",
      "small": "",
      "loading": _vm.searchRequest.loading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.searchClients(_vm.searchString)
      }
    }
  }, [_vm._v("Continue search on server")]), _vm._v(" "), (_vm.withCreate) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "small": "",
      "outline": "",
      "outlined": ""
    },
    on: {
      "click": _vm.newClient
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("person_add")]), _vm._v("\n          New\n        ")], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.clientsRequest.loading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.getClients(1, _vm.pageSize)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1)], 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-actions', [_vm._v("\n        Showing " + _vm._s(Math.min(_vm.limit, _vm.clients.length)) + " of " + _vm._s(_vm.clients.length) + "\n        "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.clientsRequest.loading,
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.getClients(1, _vm.pageSize)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f80c2c44","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/ClientList.vue
// module id = 1551
// module chunks = 9